import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";

export type PressRelease = {
  id?: number;
  created_at?: string;
  file_url: string;
  alias: string;
  is_active: boolean;
};

export const pressReleasesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getPressReleases: build.query<PressRelease[], void>({
      queryFn: async () => {
        const { data, error } = await supabase
          .from("press_releases")
          .select("*")
          .order("created_at", { ascending: false });

        if (error) return { error };
        return { data: data || [] };
      },
      providesTags: ["press-releases"],
    }),

    addPressRelease: build.mutation<any, Omit<PressRelease, "id" | "created_at">>({
      queryFn: async (pressRelease) => {
        const { data, error } = await supabase
          .from("press_releases")
          .insert(pressRelease)
          .select()
          .single();

        if (error) return { error };
        return { data };
      },
      invalidatesTags: ["press-releases"],
    }),

    updatePressRelease: build.mutation<any, Partial<PressRelease> & { id: number }>({
      queryFn: async ({ id, ...rest }) => {
        const { data, error } = await supabase
          .from("press_releases")
          .update(rest)
          .eq("id", id)
          .select()
          .single();

        if (error) return { error };
        return { data };
      },
      invalidatesTags: ["press-releases"],
    }),

    deletePressRelease: build.mutation<any, number>({
      queryFn: async (id) => {
        const { data, error } = await supabase
          .from("press_releases")
          .delete()
          .eq("id", id);

        if (error) return { error };
        return { data };
      },
      invalidatesTags: ["press-releases"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPressReleasesQuery,
  useAddPressReleaseMutation,
  useUpdatePressReleaseMutation,
  useDeletePressReleaseMutation,
} = pressReleasesApi;
